import React from 'react';
import styled from 'styled-components';
import { BaseComponent } from '../BaseComponent';

const Decorator = styled.div`
  background-color: #ddd;
  color: #888;
  padding: 0 6px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export class IconRightDecorator extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  render() {
    return <Decorator>{this.props.icon}</Decorator>;
  }
}
